export const FUND_STATUS_LABELS = {
  ACTIVE_STATUS: 'Active',
  INACTIVE_STATUS: 'Inactive',
  NEW_STATUS: 'New',
  NOT_SENT: 'Not Sent',
  PENDING_ACTIVATION_STATUS: 'Pending Add',
  PENDING_DEACTIVATION_STATUS: 'Pending Deactivation'
};
